import type { Theme } from "@mui/material"
import { assertNever } from "@pharmupp/p3-front-commons"

export enum Kinds {
  CHALLENGE = "CHALLENGE",
  OTHER = "OTHER",
}

export const getLabColorByKind = (
  kind: Kinds,
  palette: Theme["palette"],
): string => {
  switch (kind) {
    case Kinds.CHALLENGE:
      return "#c4bbf6"
    case Kinds.OTHER:
      return palette.common.digitalLavender
    default:
      return assertNever(kind, "#f4f5fa", "getLabColorByKind labColors.ts")
  }
}
